let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dZq4P")).then(() => parcelRequire('4Ozfu'));